/**
 * Global Imports
*/

import PropTypes from 'prop-types';
import React from 'react';

/**
 * Root Imports
*/

import { CssClassName } from '~/util/Css';

/**
 * Exports
*/

/**
 * 
 */
export function Box(props) {
  return (
    <div className={ CssClassName([ `p-${ props.padding } bg-white shadow`, props.className ]) }>
      { props.children }
    </div>
  );
}

Box.propTypes = {
  padding: PropTypes.number
};

Box.defaultProps = {
  padding: 4
};